import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { Flex } from 'components/styled/containers/flex'
import { Body, H1 } from 'components/styled/typography'
import { PageContent } from 'components/styled/page/page-content'
import { Header } from 'components/styled/header'

interface ErrorProps {
  heading?: string
  content?: string
  children?: React.ReactNode
  showHeader?: boolean
}

export function Error({
  children,
  heading,
  content,
  showHeader = false,
}: ErrorProps) {
  return (
    <>
      {showHeader && (
        <Header>
          <H1>{heading}</H1>
        </Header>
      )}
      <PageContent size="small">
        <Flex
          flexDirection="column"
          mt={showHeader ? 's64' : 's128'}
          alignItems="center"
          justifyContent="center"
        >
          {heading && !showHeader && (
            <H1 color="bodyText" textAlign="center">
              {heading}
            </H1>
          )}
          {content && (
            <Body textAlign={showHeader ? 'left' : 'center'}>{content}</Body>
          )}
          {children}
        </Flex>
      </PageContent>
    </>
  )
}

export default connect(mapLanguageToComponentProps())(Error)
